const INVITEPAX_RESULT = (state, invitePaxs) => {
  state.invitePaxs = invitePaxs
}
export default {
  INVITEPAX_RESULT
}
